import React from 'react';
import headerActions from '../../../../actions/header';
import CategoryLink from '../category';

export default class Discover extends React.Component {
  static propTypes = {
    categories:            React.PropTypes.array,
    maxVisibleCategories:  React.PropTypes.number,
    nested:                React.PropTypes.bool,
    customNavigationItems: React.PropTypes.array
  };

  closePanel = () => {
    headerActions.toggleMidPanel();
  };

  renderLinks = (activeCategoryData) => {
    if (activeCategoryData) {
      return activeCategoryData.minor.map((cat, idx) => (
        <CategoryLink
          {...cat}
          majorCategoryIndex={activeCategoryData.index}
          key={`${cat.name}_${activeCategoryData.index}`}
        />
      ));
    }
  };

  renderCategory = (activeCategory) => {
    return (
      <div className="minorcategories__columns__column">
        <h3 className="header__panel__title" data-component="minorCategoryPanelHeader">
          <a
            href={activeCategory.url}
            className="header__panel__title__link">{activeCategory.name}</a>
        </h3>
        <ul className="minorcategories__list--multiple">
          {this.renderLinks(activeCategory)}
        </ul>
      </div>
    );
  };

  renderCategories = () => {
    var startIdx = this.props.maxVisibleCategories;

    // Max visible items may be larger than the number of categories due to
    // custom navigation items. Make sure not to exceed teh bound.
    if (this.props.categories.length <= startIdx) {
      return;
    }

    var moreCategories = this.props.categories.slice(startIdx);

    return moreCategories.map(function (category) {
      return this.renderCategory(category);
    }, this);
  };

  /**
   * Renders any custom navigation items.
   *
   * @param bool forceShow If true always output the custom navigation items
   *
   * @returns {*}
   */
  renderCustomNavigationItems = () => {
    // See if we have any
    if (!this.props.customNavigationItems) return;

    // Check if we display all or just some
    var startIdx = this.props.maxVisibleCategories - this.props.categories.length;
    if (startIdx < 0) {
      startIdx = 0;
    }

    var items = this.props.customNavigationItems.slice(startIdx);

    return items.map(function (item, idx) {
      return (
        <div
          className="minorcategories__columns__column"
          key={`${item.text}_${item.url}`}
        >
          {this.renderCustomNavigationItem(item)}
        </div>
      );
    }, this);
  };

  /**
   * Renders a single custom navigation item
   *
   * @param item The item data
   *
   * @returns {XML}
     */
  renderCustomNavigationItem = (item) => {
    var target = item.openInTab ? '_blank' : '_self';

    return (
      <h3 className="header__panel__title" data-component="minorCategoryPanelHeader">
        <a
          href={item.url}
          className="header__panel__title__link"
          target={target}
          rel="nofollow"
          data-component="custom-navigation-item">
          <span className="custom-navigation__item--txt">{item.text}</span>
        </a>
      </h3>
    );
  };

  render () {
    var containerClass = this.props.nested
                       ? 'minorcategories--nested is-more'
                       : 'minorcategories is-more';

    return (
      <div className={containerClass}>
        <div className="minorcategories__columns">
          {this.renderCategories()}
          {this.renderCustomNavigationItems()}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/header/minorcategories/more/index.js